// TODO: limit upload size

import React, { useRef } from 'react'
import Button from '@material-ui/core/Button'
import { red } from '@material-ui/core/colors'
import { TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: 16,
    minWidth: 200,
  },
}))

export default function UploadFile(props) {
  const { fileName, moreInfo, receiveFile, change, error } = props

  const classes = useStyles()

  const pickFile = useRef(null)

  const handlePickFile = () => {
    pickFile.current.click()
  }

  const handleChange = (id, e) => {
    const copy = { ...moreInfo }
    const value = e.target.value
    copy.caption = value
    change(copy)
  }

  return (
    <div>
      <input
        ref={pickFile}
        style={{ display: 'none' }}
        type="file"
        accept="image/jpg, image/jpeg, image/png, image/tiff, image/webp"
        onChange={(e) => receiveFile(e, 'pickFile')}
      />
      <Button variant="contained" color="secondary" onClick={handlePickFile}>
        Pick File
      </Button>
      <div>{fileName}</div>

      <TextField
        label={'Caption (optional)'}
        className={classes.textField}
        inputProps={{
          maxLength: 80,
        }}
        value={moreInfo.caption}
        onChange={(e) => handleChange('caption', e)}
        multiline
        margin="normal"
        disabled={error !== '' || fileName === ''}
      />

      <div
        style={{
          fontSize: 16,
          display: error ? 'block' : 'none',
          color: red[500],
        }}
      >
        {error}
      </div>
    </div>
  )
}
